'use client'
import type { SPContext } from '@hooks/use-analytics'
import { createContext } from 'react'
import type { UserProfile } from '@lib/types'
export type TPageContext = Extract<SPContext, { name: 'page' }>
export type TPlaceContext = Extract<SPContext, { name: 'place' }>
export type TProviderContext = Extract<SPContext, { name: 'provider' }>
export type TUserContext = Extract<SPContext, { name: 'scmg_user' }>
export type TContentContext = Extract<SPContext, { name: 'content' }>

export const PageContext = createContext<TPageContext | null>(null)
export const BlockContext = createContext<TContentContext | null>(null)
export const ItemContext = createContext<TContentContext | null>(null)
export const UserContext = createContext<TUserContext | null>(null)

export const extractUserSessionForAnalytics = (profile: UserProfile): TUserContext => {
  const roles: string[] = []
  let regions: string[] = []

  profile.affiliations.forEach(a => {
    roles.push(a.role)
    regions = regions.concat(a.regions)
  })

  const userInfo: TUserContext = {
    name: 'scmg_user',
    data: {
      user_id: profile.userid,
      ad_username: profile.username,
      first_name: profile.firstname,
      last_name: profile.lastname,
      email: profile.email,
      region: [...new Set(regions)],
      group: profile.n2kgroups,
      role: [...new Set(roles)],
    },
  }

  return userInfo;
}